import { format } from 'date-fns';
import { Skeleton } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { useSimulationMeta } from '../hooks';

type SimulationTitleProps = {
  id: number;
};

export const SimulationTitle = ({ id }: SimulationTitleProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { data: meta, isLoading } = useSimulationMeta(String(id));

  if (isLoading || !meta) {
    return <Skeleton className="h-7 w-100" />;
  }

  const fromFormatted = format(new Date(meta.from), 'dd.MM.');
  const toFormatted = format(new Date(meta.to), 'dd.MM.yyyy');

  return <div className="text-t24-sb">{tWrapper('simulationTitle', { id, from: fromFormatted, to: toFormatted })}</div>;
};
